// Perfiles del equipo de MorphenIQ.
// Para agregar un perfil real: completa id, name, roleKey, image, bioKey, tagKeys y deja placeholder en false.
// Los textos (cargo, biografía y etiquetas) viven en las traducciones (src/i18n/local/*/common.ts)
// bajo las claves 'about.team.m.<id>.role', '.bio' y '.tags'.
// Mientras un perfil no esté listo, deja placeholder en true para mostrar la tarjeta "Próximamente".

export const teamMembers = [
  {
    id: 'jorge',
    name: 'Jorge Enrique Cortés Díaz',
    roleKey: 'about.team.m.jorge.role',
    image: 'https://public.readdy.ai/ai/img_res/edited_6ffd5a6a89f2d42225e5c3870d55dd2d_99373ebe.jpg',
    bioKey: 'about.team.m.jorge.bio',
    tagKeys: 'about.team.m.jorge.tags',
    placeholder: false,
  },
  {
    id: 'ivan',
    name: 'Iván Díaz Cervantes',
    roleKey: 'about.team.m.ivan.role',
    image: 'https://public.readdy.ai/ai/img_res/edited_6c5e95f9f07a930e32278d5ae7f7de45_99373ebe.jpg',
    bioKey: 'about.team.m.ivan.bio',
    tagKeys: 'about.team.m.ivan.tags',
    placeholder: false,
  },
  {
    id: 'maria',
    name: 'María Angélica Cortés Niño',
    roleKey: 'about.team.m.maria.role',
    image: 'https://public.readdy.ai/ai/img_res/edited_89e152a2aae032f27f6b36f0e6a53da8_99373ebe.jpg',
    bioKey: 'about.team.m.maria.bio',
    tagKeys: 'about.team.m.maria.tags',
    placeholder: false,
  },
  {
    id: 'claudia',
    name: 'Claudia Inés Cortés Díaz',
    roleKey: 'about.team.m.claudia.role',
    image: 'https://public.readdy.ai/ai/img_res/edited_e7ede7a1268ea707920834f0acaed15e_41ad9e34.jpg',
    bioKey: 'about.team.m.claudia.bio',
    tagKeys: 'about.team.m.claudia.tags',
    placeholder: false,
  },
  {
    id: 'william',
    name: 'William Enrique Pallares De La Rosa',
    roleKey: 'about.team.m.william.role',
    image: 'https://static.readdy.ai/image/104a0c87a06b5548a14575dc21f9cc26/110fe8a49a53659f7380402d2c4d5d9e.jpeg',
    bioKey: 'about.team.m.william.bio',
    tagKeys: 'about.team.m.william.tags',
    placeholder: false,
  },
  {
    id: 'evilio',
    name: 'Evilio Mario Polo Molina',
    roleKey: 'about.team.m.evilio.role',
    image: 'https://public.readdy.ai/ai/img_res/0b3be4b8-7a89-446c-b2b8-17f9aa8b9535.png',
    bioKey: 'about.team.m.evilio.bio',
    tagKeys: 'about.team.m.evilio.tags',
    placeholder: false,
  },
];